import { DocusealForm } from "@docuseal/react"
import React, { useContext, useState } from "react"
import { useQuery } from "react-query"

import AlertBanner from "src/components/AlertBanner"

import { reviewAgreement } from "src/api/Contracts/SignContract"

import { logger } from "src/utils/datadog"

import { SignContractWizardContext } from "../SignContractWizardContext"

const DocusealSigningForm = () => {
  const {
    agreementOverview,
    docusealSubmitterSlug,
    dispatch,
    dockwaLogo,
    quote,
    surchargeCopy,
    state,
    withTemplate,
    wizardCopy,
  } = useContext(SignContractWizardContext)
  const [key, setKey] = useState(Date.now())

  useQuery(
    ["reviewAgreement", quote.encodedId, state.paymentMethod],
    () =>
      reviewAgreement({
        quoteId: quote.encodedId,
        paymentMethodId: state.paymentMethod,
      }),
    {
      refetchInterval: 2000,
      enabled:
        agreementOverview &&
        withTemplate &&
        state.docusealFormSubmitted &&
        !state.reviewReady,
      onSuccess: (data) => dispatch({ type: "REVIEW_LOADED", payload: data }),
    }
  )

  const handleComplete = (data) => {
    const { status } = data

    if (status === "completed") {
      logger.info("Docuseal submission completed - starting review polling", {
        quoteId: quote.encodedId,
        submissionStatus: status,
        contractSigningFormState: state,
      })

      dispatch({
        type: "DOCUSEAL_FORM_SUBMITTED",
        payload: { fresh: true },
      })
      setKey(Date.now())
    }
  }

  const handleOnLoad = (data) => {
    if (
      data.completed_submitter &&
      !state.docusealFormSubmitted &&
      !state.docusealFormCompleted
    ) {
      // If we load the form, and it shows as already completed, but our local state is not updated, we need to sync it
      // This would mean that somehow the server state and local storage state do not match the Docuseal state (which is the source of truth)
      logger.info(
        "Docuseal form state mismatch detected - form already completed in Docuseal - syncing state",
        {
          quoteId: quote.encodedId,
          docusealFormOnLoadData: data,
          contractSigningFormState: state,
        }
      )
      dispatch({ type: "DOCUSEAL_FORM_SUBMITTED" })
    }
  }

  const renderSurchargeNotice = () => {
    if (agreementOverview) return null

    if (surchargeCopy) {
      return (
        <div className="my-5">
          <AlertBanner type="info">{surchargeCopy}</AlertBanner>
        </div>
      )
    }
  }

  return (
    <>
      {state.reviewFallback && (
        <div className="mb-5">
          <AlertBanner type="warning">
            {wizardCopy.signatureUnconfirmed}
          </AlertBanner>
        </div>
      )}
      <DocusealForm
        src={`https://docuseal.co/s/${docusealSubmitterSlug}`}
        key={key}
        logo={dockwaLogo}
        onComplete={handleComplete}
        onLoad={handleOnLoad}
        sendCopyEmail={false}
        withTitle={false}
        withSendCopyButton={false}
        allowToResubmit={false}
        expand={false}
        withDownloadButton={false}
        withDecline={false}
        goToLast={false}
        i18n={{
          form_has_been_submitted_already: " ",
          "form_has_been_archived.":
            "There have been changes made to this agreement, please refresh the page and try signing again.",
        }}
      />
      {renderSurchargeNotice()}
    </>
  )
}

export default DocusealSigningForm
